export const mbcSearchModule = 'mbcSearch';

export const ANY_COUNCIL_VALUE = 'ANY_COUNCIL';
export const NON_US_VALUE = 'NON_US';

export enum AvailabilityFilterOptions {
  AVAILABLE = 'Available',
  BUSY = 'Busy',
  BOTH = 'Both',
}

export enum CounselorAvailabilityShort {
  AVAILABLE = 'CA_Available',
  BUSY = 'CA_Busy',
}

export enum SearchTableActions {
  ASSIGN = 'assign',
}

export enum TableMode {
  ASSIGN_BADGES = 'ASSIGN_BADGES',
  ASSIGN_MBCS = 'ASSIGN_MBCS',
}

export type AvailabilityShortToAvailabilityType =
  keyof typeof AvailabilityShortToAvailability;

export const AvailabilityShortToAvailability = {
  [CounselorAvailabilityShort.AVAILABLE]: AvailabilityFilterOptions.AVAILABLE,
  [CounselorAvailabilityShort.BUSY]: AvailabilityFilterOptions.BUSY,
};

export enum GuidType {
  COUNCIL = 'Council',
  DISTRICT = 'District',
  ANY_COUNCIL = 'Any Council',
}

export enum proximityFilterLabels {
  MILES_5 = '5 miles',
  MILES_10 = '10 miles',
  MILES_25 = '25 miles',
  MILES_50 = '50 miles',
  ANY = 'Any distance',
}

export enum proximityFilterId {
  MILES_5 = 5,
  MILES_10 = 10,
  MILES_25 = 25,
  MILES_50 = 50,
  ANY = 0,
}

export const ProximityFilterOptions = [
  {
    id: proximityFilterId.MILES_5,
    label: proximityFilterLabels.MILES_5,
  },
  {
    id: proximityFilterId.MILES_10,
    label: proximityFilterLabels.MILES_10,
  },
  {
    id: proximityFilterId.MILES_25,
    label: proximityFilterLabels.MILES_25,
  },
  {
    id: proximityFilterId.MILES_50,
    label: proximityFilterLabels.MILES_50,
  },
  {
    id: proximityFilterId.ANY,
    label: proximityFilterLabels.ANY,
  },
];

export enum OrganizationPositionType {
  UNIT = 'Unit',
  DISTRICT = 'District',
  COUNCIL = 'Council',
}

export enum MBCSearchFields {
  MERIT_BADGES = 'meritBadges',
  ORG_GUID_TYPE = 'orgGuidType',
  AVAILABILITY = 'availability',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  MEMBER_ID = 'memberId',
  ZIP_CODE = 'zipCode',
  PROXIMITY = 'proximity',
}

export enum MBCSearchTableFields {
  DISTANCE = 'distance',
  LAST_NAME = 'lastName',
}

export const ALL_MERIT_BADGES = {
  label: 'Merit Badge Counselors with MBs',
  value: 0,
};

export const NO_MERIT_BADGES = {
  label: 'Merit Badge Counselors without MBs',
  value: 'No',
};

export const BOTH_ALL_NO_MERIT_BADGES = {
  label: 'All Merit Badge Counselors (with/without MBs)',
  value: 'Both',
};

export const usersLevelUnit = [
  'Advancement Approver',
  'Venturing Crew Advisor',
  'Unit Support',
  'Unit Advancement Chair',
  'Skipper',
  'Scoutmaster',
  'Merit Badge Administrator',
  'Key 3 Delegate',
  'Council Unit Representative',
  'COR/CUR Delegate',
  'Committee Chair',
  'Chartered Organization Rep.',
  'Club Sponsor',
  'Associate Sponsor',
  'Cubmaster',
  'Exploring Post Advisor',
];

export const usersLevelDistrict = [
  'Unit Commissioner',
  'Senior District Executive',
  'Asst Roundtable Commissioner',
  'Roundtable Commissioner',
  'Field Director',
  'District Service Team Chair',
  'District Executive',
  'District Director',
  'District Commissioner',
  'District Advancement Chair',
  'District Advancement Committee Chair',
  'District Advancement Committee Member',
  'Asst. District Commissioner',
  'Asst. Roundtable Commissioner',
];

export const usersLevelCouncil = [
  'Assistant Council Commissioner',
  'Assistant Scout Executive',
  'Registration Support',
  'Scout Executive',
  'Director of Field Service',
  'Council Commissioner',
  'Council Admin',
  'Council Advancement Committee Chair',
  'Council Advancement Committee Member',
  'Registration Inquiry',
  'Council President',
  'Director Field Service',
];

export const usersLevelNational = [
  'National Commissioner Service',
  'National Scout Commissioner',
  'Advancement Editor',
  'Sub-Unit Support',
];

export const usersDistrictAdmins = [
  'District Executive',
  'District Director',
  'Key 3 Delegate',
  'Senior District Executive',
  'District Advancement Chair',
  'District Advancement Committee Chair',
  'District Advancement Committee Member',
];

export const usersCouncilAdmins = [
  'Scout Executive',
  'Key 3 Delegate',
  'Registration Support',
  'Council Admin',
  'Field Director',
  'Director of Field Service',
  'Assistant Scout Executive',
  'Council Advancement Committee Chair',
  'Council Advancement Committee Member',
];

export const allowedPositionsMBoption = [
  'Scout Executive',
  'Key 3 Delegate',
  'Registration Support',
  'Council Admin',
  'District Executive',
  'District Director',
  'Senior District Executive',
  'Field Director',
  'Director of Field Service',
  'Assistant Scout Executive',
  'National Commissioner Service',
  'National Scout Commissioner',
  'Council Commissioner',
  'Assistant Council Commissioner',
  'District Commissioner',
  'Assistant District Commissioner',
  'Roundtable Commissioner',
  'Assistant Roundtable Commissioner',
  'Unit Commissioner',
  'District Service Team Chair',
  'Registration Inquiry',
  'District Advancement Chair',
  'District Advancement Committee Member',
  'Council Advancement Committee Chair',
  'Council Advancement Committee Member',
];

export const mbcSearchOptions = [
  {
    value: ALL_MERIT_BADGES.value,
    label: ALL_MERIT_BADGES.label,
    allowedPositions: [],
  },
  {
    value: NO_MERIT_BADGES.value,
    label: NO_MERIT_BADGES.label,
    allowedPositions: allowedPositionsMBoption,
  },
  {
    value: BOTH_ALL_NO_MERIT_BADGES.value,
    label: BOTH_ALL_NO_MERIT_BADGES.label,
    allowedPositions: allowedPositionsMBoption,
  },
];
